import React from "react"

export default function AcceptableTypesOfIdentificationSubtitle() {
	return (
		<>
			If a new application is created with an identification type not checked below, the application will be
			automatically denied.
			<br />
			If an existing customer has an unapproved identification type, they will be unable to open any new account(s).
		</>
	)
}
